import {api, parseAPIError} from "../../services/api";
import Cookies from "universal-cookie";
import http from "../../http";

export function removeAuthentication() {
  const cookies = new Cookies();
  cookies.remove("userAuth", {path: "/"});
  localStorage.removeItem("userPermissions");
}

export async function login(input) {
  try {
    const apiLogin = http.create({});
    const r = await apiLogin.post("/login", input);
    return r.data.data
  } catch (err) {
    throw parseAPIError(err)
  }
}

export async function logout() {
  try {
    await api.get("/logout");
    removeAuthentication();
  } catch (err) {
    throw parseAPIError(err);
  }
}

export async function getProfile() {
  try {
    const r = await api.get("/users/profile");
    return r.data.data;
  } catch (err) {
    throw parseAPIError(err);
  }
}

export async function changePassword(data) {
  try {
    await api.post("/users/password-change", data);
  } catch (err) {
    throw parseAPIError(err);
  }
}
